import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { ADS_RETRIEVAL_SERVICE_NAVCARD } from '@web-platform/shared-universal-types/src/network/requestTypes';

import type { NavCardCreative } from '@web-platform/shared-universal-types/src/network/endpoints/adsRetrievalService';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  NavCard,
  NavCardById,
  NavCardState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/navCard';

export const INITIAL_STATE: NavCardState = {
  byId: {},
};

// SHIBA-606 Refactor this and transformHomepageCardCreativeToAdvert to util
const transformNavCardCreativeToAdvert = (cardCreative: NavCardCreative): NavCard => {
  const { fields, pixels, priority } = cardCreative;

  return {
    analyticsProperties: {
      idSponsor: cardCreative.id_sponsor,
      idCreative: cardCreative.id_creative,
      idCampaign: cardCreative.id_campaign,
      idPlacement: cardCreative.id_placement,
      idTracking: cardCreative.id_tracking,
      idFormat: cardCreative.id_format,
      priority,
    },
    defaultTranslations: {
      headline: cardCreative.fields.headline,
      ctaUrl: cardCreative.fields.ctaUrl,
    },
    creative: {
      fields,
      format: cardCreative.id_format,
    },
    pixels,
    performanceEventsPayloads: cardCreative.performanceEventsPayloads,
  };
};

const byId = (state: NavCardById, action: Action): NavCardById => {
  if (
    !('payload' in action) ||
    action.payload === null ||
    typeof action.payload !== 'object' ||
    !('type' in action.payload) ||
    !('response' in action.payload)
  ) {
    return state;
  }
  switch (action.payload.type) {
    case ADS_RETRIEVAL_SERVICE_NAVCARD: {
      if (action.payload.response.error) {
        // Flag to differenciate between empty response and error response,
        // so we can log both events separately in the react component

        // @ts-expect-error SHIBA-897: this is impossible to type without casting or a major logic change
        return { ...state, isError: true };
      }

      const {
        body: { creatives },
      } = action.payload.response;

      const navCards: NavCardById = {};
      Object.keys(creatives).forEach((navCardSlotId) => {
        navCards[navCardSlotId] = transformNavCardCreativeToAdvert(creatives[navCardSlotId]);
      });
      return navCards;
    }

    default:
      return state;
  }
};

const navCardReducer = (state: NavCardState = INITIAL_STATE, action: Action): NavCardState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export default navCardReducer;
